import { requestApi } from './Api';

export const getSupervisingProviders = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/supervising_provider/get'
  });

export const updateSupervisingProvider = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/supervising_provider/update'
  });

export const deleteSupervisingProvider = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/supervising_provider/delete'
  });

export const createSupervisingProvider = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/supervising_provider/create'
  });

export const searchProvider = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/npi/get'
  });
